import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
    playlists : localStorage.getItem('parentCorps') && JSON.parse(localStorage.getItem('parentCorps'))  || [],
    filterResults: '',
    parentCorpUserList: null
};

const module = {
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/parentCorporations/index.js